import { ViewContainerRef, Directive } from '@angular/core';
@Directive({
    selector: '[controls-container]'
})
export class ControlsContainerDirective{
    constructor(public viewContainerRef: ViewContainerRef){
    }
}